<template>
  <div>
    <v-container>
      <v-row>
        <v-col xs12 sm6 md5>
          <v-col xs12 sm12 md12>
            <v-text-field
              label="Short Code"
              v-model="sms.shortCode"
              :disabled="!onEdit"
            ></v-text-field>
          </v-col>
          <v-col xs12 sm12 md12>
            <v-text-field
              label="Code"
              v-model="sms.code"
              :disabled="!onEdit"
            ></v-text-field>
          </v-col>
          <v-col xs12 sm12 md12>
            <v-text-field
              label="App ID"
              v-model="sms.appId"
              :disabled="!onEdit"
            ></v-text-field>
          </v-col>
          <v-col xs12 sm12 md12>
            <v-text-field
              label="App Secret"
              v-model="sms.appSecret"
              :disabled="!onEdit"
            ></v-text-field>
          </v-col>
          <v-col xs12 sm12 md12>
            <v-checkbox
              label="Active"
              v-model="sms.isActive"
              :disabled="!onEdit"
            ></v-checkbox>
          </v-col>
          <v-col xs12 sm12 md12>
            <v-btn text outlined @click="onEdit = true">Edit</v-btn>&nbsp;
            <v-btn
              text
              outlined
              :loading="isSaving"
              @click="save"
              :disabled="!onEdit"
              >Save</v-btn
            >&nbsp;
            <v-btn text outlined @click="onEdit = false" :disabled="!onEdit"
              >cancel</v-btn
            >
          </v-col>

          <v-col xs12 sm12 md12 v-if="onEdit">
            <v-text-field
              label="Contact #"
              v-model="contactNum"
              :disabled="!onEdit"
              hint="09XXXXXXXXX or 639XXXXXXXXX"
              persistent-hint
            ></v-text-field>
          </v-col>

          <v-col xs12 sm12 md12 v-if="onEdit">
            <v-btn
              text
              outlined
              @click="test"
              :disabled="!onEdit"
              :loading="isTesting"
              >Test</v-btn
            >
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import isEmpty from "lodash/isEmpty";
const API_ENDPOINT = "/api/smsConfig";
export default {
  data: () => ({
    sms: {},
    isSaving: false,
    onEdit: false,
    isTesting: false,
    contactNum: "",
  }),
  methods: {
    save() {
      this.isSaving = true;
      this.$axios
        .post(`${API_ENDPOINT}/sms-globe`, this.sms)
        .then(({ data }) => {
          this.$toast.success(data.message);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    getSMS() {
      this.$axios
        .get(`${API_ENDPOINT}/sms-globe`)
        .then(({ data }) => {
          if (!isEmpty(data)) {
            this.sms = data;
          }
        })
        .catch(({ response }) => {
          this.$toast.show(response.data);
        });
    },
    test() {
      if (!isEmpty(this.contactNum)) {
        this.isTesting = true;
        this.$axios
          .post(`${API_ENDPOINT}/sms-globe/test?contactNum=${this.contactNum}`)
          .then(({ data }) => {
            this.$toast.success(data);
          })
          .catch(({ response }) => {
            this.$toast.error(response.data);
          })
          .finally(() => {
            this.isTesting = false;
          });
      } else {
        this.$toast.error("Contact Number is required.");
      }
    },
  },
  created() {
    this.getSMS();
  },
};
</script>
